import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getParamAsInt } from "../../../app/utils";

// Reads districtId/schoolId from the URL query string (used to deep-link into
// a specific district/school on the reports pages), and clears them from the
// URL once they've been read so that subsequent manual filter changes aren't
// overwritten by a stale query string.
export function useAdminReportsUrlParams() {
	const [queryParams, setSearchParams] = useSearchParams();
	const districtIdParam = getParamAsInt(queryParams, "districtId") ?? null;
	const schoolIdParam = getParamAsInt(queryParams, "schoolId") ?? null;

	useEffect(() => {
		if (districtIdParam !== null || schoolIdParam !== null) {
			setSearchParams({}, { replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [districtIdParam, schoolIdParam]);

	return { districtIdParam, schoolIdParam };
}
